/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.11.24
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class KeyActionListener extends BaseObject {

	constructor(listener, target = document) {
		super();
		if (typeof listener !== 'function') {
			throw new Error('Listener must be a function');
		}

		this.listener = listener;
		this.handleKeyDown = this.handleKeyDown.bind(this);

		this.target = target;

		// Attach the keydown event listener
		this.target.addEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown(event) {
		if (this.isInputFocused()) {
			return;
		}
		const { key, ctrlKey, metaKey } = event; // `metaKey` for Mac users (Cmd key)
		let ctrl = ctrlKey || metaKey;
		let action = null;

		if (key === 'Delete') {
			action = 'delete';

		//disable ctrl + c,v,z for now: we need an option to disable it programmatically when the right menu is shown for genograms. Otherwise trying to copy/paste/undo text for nodes copies the nodes themselves screwing the genogram
		} else if (ctrl && key === 'c') {
			action = 'copy';
		} else if (ctrl && key === 'v') {
			action = 'paste';
		} else
			if (ctrl && key === 'z') {
			action = 'undo';
		} else if (ctrl && key === 'y') {
			action = 'redo';
		} else if (ctrl && key === 'a') {
			action = 'selectall';
		} else if(ctrl && key === 's'){
			action = 'save';
		} else if(key === '+'){
			action = 'zoomin';
		} if(key === '-'){
			action = 'zoomout';
		}


		// Call the listener if an action is detected
		if (action) {
			event.preventDefault();
			this.listener(action, event);
		}
	}

	isInputFocused() {
		const active = document.activeElement;
		return (
			active &&
			(
				active.tagName === 'INPUT' ||
				active.tagName === 'TEXTAREA' ||
				active.isContentEditable
			)
		);
	}

	// Detach the event listener when the class is no longer needed
	destroy() {
		this.target.removeEventListener('keydown', this.handleKeyDown);
	}
}
